import apiService from "../services/apiService";

const loginObj = JSON.parse(localStorage.getItem("auth")) || {};
const productsUrl = "accountingapi/GetProduct/";

export const getProduct = async () => {
  const response = await apiService.get(
    `${productsUrl}?org=${loginObj.org}&is_archive=false`
  );
  return response;
};

export async function createProduct(payload) {
  const headers =
    payload instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const response = await apiService.post(
    `${productsUrl}?org=${loginObj.org}`,
    payload,
    { headers }
  );

  return response;
}

export async function updateProduct(id, payload) {
  const response = await apiService.patch(
    `${productsUrl}${id}/?org=${loginObj.org}`,
    payload
  );
  return response;
}

export async function getProductById(id) {
  const response = await apiService.get(
    `/GetProduct/${id}/?org=${loginObj.org}`
  );
  return response;
}
